import { defineMessages } from 'react-intl';

const baseId = 'app.containers.OAuth2ConfigurationForm';

export const messages = defineMessages({
  clientKey: {
    id: `${baseId}.clientKey`,
    defaultMessage: 'Client Key',
  },
  clientKeyPlaceholder: {
    id: `${baseId}.clientKeyPlaceholder`,
    defaultMessage: 'Enter the key provided by your OAuth provider',
  },
  clientSecret: {
    id: `${baseId}.clientSecret`,
    defaultMessage: 'Client Secret',
  },
  clientSecretPlaceholder: {
    id: `${baseId}.clientSecretPlaceholder`,
    defaultMessage: 'Enter secure confidential key',
  },
  name: {
    id: `${baseId}.name`,
    defaultMessage: 'Name',
  },
  namePlaceholder: {
    id: `${baseId}.namePlaceholder`,
    defaultMessage: 'Enter a name for this OAuth configuration',
  },
  pageTitle: {
    id: `${baseId}.pageTitle`,
    defaultMessage: 'OAuth 2.0 Configuration',
  },
  pageDescription: {
    id: `${baseId}.pageDescription`,
    defaultMessage:
      'Configure your OAuth 2.0 credentials to enable secure authentication with an external service. OAuth 1.0 is not supported.',
  },
  back: {
    id: `${baseId}.back`,
    defaultMessage: 'Back',
  },
  tokenUrl: {
    id: `${baseId}.tokenUrl`,
    defaultMessage: 'Token URL',
  },
  tokenUrlPlaceholder: {
    id: `${baseId}.tokenUrlPlaceholder`,
    defaultMessage: 'https://oauth.example.com/token',
  },
  nameRequired: {
    id: `${baseId}.nameRequired`,
    defaultMessage: 'Name is required.',
  },
  clientKeyRequired: {
    id: `${baseId}.clientKeyRequired`,
    defaultMessage: 'Client Key is required.',
  },
  clientSecretRequired: {
    id: `${baseId}.clientSecretRequired`,
    defaultMessage: 'Client Secret is required.',
  },
  tokenUrlRequired: {
    id: `${baseId}.tokenUrlRequired`,
    defaultMessage: 'Token URL is required.',
  },
  saveSuccess: {
    id: `${baseId}.saveSuccess`,
    defaultMessage: 'OAuth 2.0 configuration saved successfully.',
  },
  updateSuccess: {
    id: `${baseId}.updateSuccess`,
    defaultMessage: 'OAuth 2.0 configuration updated successfully.',
  },
  error: {
    id: `${baseId}.error`,
    defaultMessage:
      'An error occurred while saving the OAuth 2.0 configuration.',
  },
});
